/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useRef, useState, useContext, useEffect } from "react";
import {
  Container,
  ButtonContainer,
  Content,
  Scrollbox,
  Table,
  TableHead,
  TableRow,
  Thead,
  Tbody,
  Td,
  BorderSwitch,
  Button,
} from "./styles";
import Switch from "react-switch";
import { Field, Form, Formik, FieldArray } from "formik";
import Colors from "constants/Colors";
import { ApiNotification } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Loader from 'components/Loader';

export default function SettingsNotifications({ changeState, showModal }) {
  const formik = useRef(Formik);
  const formikRef = useRef(Formik);
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const [userSettingsGroups, setUserSettingsGroups] = useState([{ notifications: [] }])
  const apiNotification = new ApiNotification();

  const getSettings = async () => {
    try {
      loading.start()
      apiNotification.setAuthToken(authContext.token);
      const response = await apiNotification
        .getNotificationSettings()
        .then((response) => response.json());
      loading.stop()

      if (response.ret_code !== 200) return;
      loading.stop()
      let settings = response.ret_value;
      console.log("settings", settings)
      setUserSettingsGroups(settings)
    } catch (err) {
      loading.stop()
      console.log("getNotifications err", err)
    }
  }

  const handleChangeUserSetting = async (checked, idDomain, currentStatus, type) => {
    try {
      loading.start()
      let status = 'off';
      if (checked) {
        if (currentStatus === 'off') {
          status = type
        } else if (currentStatus != type) {
          status = "both"
        } else {
          status = type
        }
      } else {
        if (currentStatus === 'off') {
          status = "off"
        } else if (currentStatus != "both") {
          status = "off"
        } else if (currentStatus === "both" && type === "system") {
          status = "email"
        } else if (currentStatus === "both" && type === "email") {
          status = "system"
        }
      }

      apiNotification.setAuthToken(authContext.token);
      const response = await apiNotification
        .updateNotificationSettings(idDomain, status)
        .then((response) => response.json());
      if (response.ret_code !== 200) return;

      getSettings()
    } catch (err) {
      loading.stop()
      console.log("getNotifications err", err)
    }
  }

  useEffect(() => {
    getSettings()
  }, [])


  return (
    <Container>
      <ButtonContainer>
        <Button
          onClick={() => {
            changeState(!showModal);
          }}
        >
          &lt; VOLTAR
        </Button>
      </ButtonContainer>
      <Content>
        <Formik initialValues={{}} innerRef={formikRef}>
          {(formikProps) => (
            <Form>
              <Scrollbox onScroll={e => e.stopPropagation()}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <Thead className="title">Notificações</Thead>
                      <Thead style={{ textAlign: "left", textDecoration: 'unset', fontWeight: 'bold' }}>Fitinsur I/O</Thead>
                      {/* <Thead style={{textDecoration: 'unset', fontWeight: 'bold'}}>E-mail</Thead> */}
                    </TableRow>
                  </TableHead>
                  <Tbody>

                    {userSettingsGroups.map(userSettingGroup => (
                      <>
                        <TableHead>
                          <TableRow>
                            <Thead className="title">{userSettingGroup.statusDescription}</Thead>
                            <Thead></Thead>
                            <Thead></Thead>
                          </TableRow>
                        </TableHead>
                        {userSettingGroup.notifications.map(userSetting => (
                          <TableRow>
                            <Td>{userSetting.statusDescription}</Td>
                            <Td>
                              <BorderSwitch>
                                <Field
                                  component={Switch}
                                  height={27}
                                  width={55}
                                  name={`lock-${userSetting.idDomain}`}
                                  checked={userSetting.userSettingsStatus === 'system' || userSetting.userSettingsStatus === 'both'}
                                  onChange={(a) => {
                                    handleChangeUserSetting(a, userSetting.idDomain, userSetting.userSettingsStatus, 'system')
                                  }}
                                  checkedIcon={false}
                                  uncheckedIcon={false}
                                  handleDiameter={20}
                                  offColor={Colors.WHITE}
                                  onColor={Colors.GRAY[6]}
                                  offHandleColor={Colors.GRAY[6]}
                                  onHandleColor={Colors.WHITE}
                                />
                              </BorderSwitch>
                            </Td>
                            <Td>
                              {/* <BorderSwitch>
                                <Field
                                  component={Switch}
                                  height={27}
                                  width={55}
                                  name={`lock-${userSetting.idDomain}`}
                                  checked={userSetting.userSettingsStatus === 'email' || userSetting.userSettingsStatus === 'both'}
                                  onChange={(a) => {
                                    handleChangeUserSetting(a, userSetting.idDomain, userSetting.userSettingsStatus, 'email')
                                  }}
                                  checkedIcon={false}
                                  uncheckedIcon={false}
                                  handleDiameter={20}
                                  offColor={Colors.WHITE}
                                  onColor={Colors.GRAY[6]}
                                  offHandleColor={Colors.GRAY[6]}
                                  onHandleColor={Colors.WHITE}
                                />
                              </BorderSwitch> */}
                            </Td>
                          </TableRow>
                        ))}
                      </>
                    ))}
                  </Tbody>
                </Table>
              </Scrollbox>
            </Form>
          )}
        </Formik>
      </Content>
    </Container>
  );
}
